import { makeStyles } from '@seekube-tech/ui';

export default makeStyles(theme => ({
  root: {
    width: '100%',
    height: 1,
    backgroundColor: theme.palette.neutral[200],
  },
}));